import React, { useState, useEffect } from "react";
import * as imageService from "../services/imageService";
import { categories } from "../enums/CategoriesEnum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { accountService } from "../services/accountService";

type Props = {
  guid: string;
  category?: string;
  width?: number;
  height?: number;
};

const Image = ({ guid, category, width, height }: Props) => {
  const user = accountService.userValue;
  const [image, setImage] = useState<string>();
  const [updateImage, setUpdateImage] = useState<string>();

  const [loading, setLoading] = useState<boolean>(true);
  const getImage = async () => {
    let img = await imageService.getImage(guid);
    if (img === "") {
      img =
        categories.find((x) => x.value === category)?.image ??
        categories[0].image;
    }
    setImage(img);
    setLoading(false);
  };

  const uploadImage = async (e: any) => {
    await imageService.uploadImage(e, setUpdateImage);
    setImage(updateImage);
  };
  const saveImage = async () => {
    if (guid && updateImage) {
      await imageService.updateImage(guid, updateImage);
      alert("Zapisano");
    }
  };

  useEffect(() => {
    setImage(updateImage);
  }, [updateImage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getImage();
  }, [guid]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {loading ? (
        <div className="spinner" />
      ) : (
        <>
          <div style={{ justifyContent: "center", width: width }}>
            <img
              src={image}
              alt="cosmetic"
              width={width}
              height={height}
              style={{ objectFit: "contain", maxHeight: 500 }}
            />
          </div>
          {user?.role === 2 && (
            <div className="d-flex justify-content-center">
              <label
                htmlFor="filePicker"
                className="single-btn btn"
                style={{
                  cursor: "pointer",
                }}
              >
                Zmień
              </label>
              <input
                id="filePicker"
                style={{ display: "none" }}
                type={"file"}
                onChange={(e) => uploadImage(e)}
              />
              <FontAwesomeIcon
                onClick={saveImage}
                color="lightgrey"
                style={{
                  fontSize: 30,
                  paddingLeft: 5,
                  cursor: "pointer",
                }}
                icon={faSave}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Image;
